import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../../../config/api';
import './Dashboard.css';

const Dashboard = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const getMaxValue = (data) => {
    if (!data || data.length === 0) return 1;
    return Math.max(...data.map(item => item.sales));
  };

  if (loading) return <div className="loading-spinner">{t('admin.loading')}</div>;

  return (
    <div className="admin-dashboard">
      <h2>{t('admin.dashboardOverview')}</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>{t('admin.totalUsers')}</h3>
          <p className="stat-number">{stats?.totalUsers || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.totalRestaurants')}</h3>
          <p className="stat-number">{stats?.totalRestaurants || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.totalStores')}</h3>
          <p className="stat-number">{stats?.totalStores || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.totalOrders')}</h3>
          <p className="stat-number">{stats?.totalOrders || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.totalSales')}</h3>
          <p className="stat-number">€{stats?.totalSales?.toFixed(2) || '0.00'}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.last7DaysSales')}</h3>
          <p className="stat-number">€{stats?.last7DaysSales?.toFixed(2) || '0.00'}</p>
        </div>
      </div>

      <div className="charts-container">
        {stats?.dailySales && stats.dailySales.length > 0 && (
          <div className="chart-container">
            <h3>{t('admin.dailySales')}</h3>
            <div className="chart-bars">
              {stats.dailySales.map((day, index) => {
                const maxSales = getMaxValue(stats.dailySales);
                return (
                  <div key={index} className="chart-bar-container">
                    <div className="chart-bar daily" style={{ height: `${(day.sales / maxSales) * 200}px` }}>
                      <span className="chart-value">€{day.sales.toFixed(0)}</span>
                    </div>
                    <span className="chart-label">{day.day}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {stats?.monthlySales && stats.monthlySales.length > 0 && (
          <div className="chart-container">
            <h3>{t('admin.monthlySales')}</h3>
            <div className="chart-bars">
              {stats.monthlySales.map((month, index) => {
                const maxSales = getMaxValue(stats.monthlySales);
                return (
                  <div key={index} className="chart-bar-container">
                    <div className="chart-bar monthly" style={{ height: `${(month.sales / maxSales) * 200}px` }}>
                      <span className="chart-value">€{month.sales.toFixed(0)}</span>
                    </div>
                    <span className="chart-label">{month.month}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {stats?.yearlySales && stats.yearlySales.length > 0 && (
          <div className="chart-container">
            <h3>{t('admin.yearlySales')}</h3>
            <div className="chart-bars">
              {stats.yearlySales.map((year, index) => {
                const maxSales = getMaxValue(stats.yearlySales);
                return (
                  <div key={index} className="chart-bar-container">
                    <div className="chart-bar yearly" style={{ height: `${(year.sales / maxSales) * 200}px` }}>
                      <span className="chart-value">€{year.sales.toFixed(0)}</span>
                    </div>
                    <span className="chart-label">{year.year}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
